import { Injectable } from '@angular/core';
import { Subject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  carrierId = new Subject<any>();
  carrierIdsUpdate = new Subject<any>();
  accessTokenUpdate = new Subject<any>();
  bidStatusUpdate = new Subject<any>();
  BidOrderUpdate = new Subject<any>();
  BidOrderStatus = new Subject<any>();
  languageUpdate = new Subject<any>();

  idleTimerUpdate = new Subject<any>();
  constructor() {

  }

  idleTimerChanges(): Observable<any> {
    return this.idleTimerUpdate.asObservable();
  }

  getCarrierIdChanges(): Observable<any> {
    return this.carrierId.asObservable();
  }

  CarrierValuesUpdated(): Observable<any> {
    return this.carrierIdsUpdate.asObservable();
  }

  setCarrierId(carrier_id: string) {
    this.carrierId.next({ carrier_id: carrier_id });
  }

  carriersUpdated(){
    this.carrierIdsUpdate.next({ changed: true });
  }

  accessTokenChanges(): Observable<any> {
    return this.accessTokenUpdate.asObservable();
  }

  setAccessTokenChanges(status: boolean) {
    this.accessTokenUpdate.next(status);
  }


  BidOrderArrived(){
    return this.BidOrderUpdate.asObservable();
  }

  setBidOrderUpdate(data:any){
    this.BidOrderUpdate.next(data);
  }

  BidOrderStopped(){
    return this.BidOrderStatus.asObservable();
  }

  setBidOrderStatus(data:any){
    this.BidOrderStatus.next(data);
  }


  bidUpdateChanges(): Observable<any> {
    return this.bidStatusUpdate.asObservable();
  }

  setBidUpdates(data: any) {
    this.bidStatusUpdate.next(data);
  }

  languageUpdateChanges(): Observable<any> {
    return this.languageUpdate.asObservable();
  }

  setLanguageUpdates(data: any) {
    this.languageUpdate.next(data);
  }

  setIdleTimer(data:any){
    this.idleTimerUpdate.next(data);
  }
}
